import React from "react";
import { ChevronDown } from "lucide-react";

type Props = {
  className?: string;
  size?: number;
};

export default function IconChevronDown({ className, size = 12 }: Props) {
  return <ChevronDown className={className} width={size} height={size} />;
}


